import { AuthService } from '../../authorization/services';
import { BaseService } from '../../base/base.service';
import { AppService } from '../../main/app.service';

export class IAuthUser {
    id?: string;
    displayName?: string;
    userName: string;
    password: string;
    email: string;
    claims: { [name: string]: any };
    roles: Array<string>;
}

export class IAuthClaims {

}

export class AuthUserService extends BaseService<IAuthUser> {

    constructor(AuthSettingsApi: Restangular.IService, protected AppService: AppService, private AuthService: AuthService, private localStorageService: any, private $q: ng.IQService) {
        'ngInject';
        super(AuthSettingsApi, AppService, 'user');
    }

    public all = (): ng.IPromise<IAuthUser[]> => {
        return this.Restangular.all(this.itemName).getList().then((response: Restangular.ICollection) => {
            this.list = response.plain();
            return this.listLoaded(this.list);
        });
    }

    public post(data): ng.IPromise<IAuthUser> {
        return this.collection.post(data).then((item: Restangular.IElement) => {
            this.AppService.NotifyService.success('Opgeslagen', 'De gegevens zijn opgeslagen');
            this.item = item.plain();
            return item.plain();
        })
        .catch((error) => {
            if(error.status == 406){
                if(error.data[0].code == "DuplicateUserName"){
                    throw "DuplicateUserName";
                }
            }
            this.AppService.NotifyService.error('Foutmelding', "Account kon niet worden opgeslagen!");
            return error;
        });
    }

    resetPassword = (user: IAuthUser) => {
        return this.collection.one(user.id).all('resetpassword').post(user).then((response) => {
            return response;
        })
    }

    getRoles = (user: IAuthUser) => {

        return this.collection.one(user.id).all('roles').getList().then((response: Restangular.ICollection) => {
            return response.plain();
        })

    }

    getClaims = (user: IAuthUser) => {
        return this.collection.one(user.id).all('claims').getList().then((response: Restangular.ICollection) => {
            return response.plain();
        })
    }

    public getCurrentUser = () => {
        var tokendata = this.AuthService.getDataFromToken(this.AuthService.GetAuthorizationData());
        var userId = (<any>tokendata).sub;
        if (this.localStorageService.get("user") && this.localStorageService.get("user").id == userId) {
            var deferred = this.$q.defer();
            var user = this.localStorageService.get("user")
            deferred.resolve(user);
            return deferred.promise;
        } else {
            return this.get(userId).then((user) => {
                return this.getClaims(user).then((claims) => {
                    return this.getRoles(user).then((roles) => {
                        user.roles = roles;
                        this.localStorageService.set("user", user);
                        return user;
                    });
                })
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/authsettings/services/authusers.service.ts